
  import EditGeneralView from '../../components/ViewTypes/EditGeneralView.vue'
  import BridgeLogView from '../../components/ViewTypes/BridgeLogView.vue'
  import { Vue, Component, Prop, Watch } from 'vue-property-decorator'

  @Component({
    components: {
      EditGeneralView,
      BridgeLogView
    }
  })

  export default class General extends Vue  {
    dialog = false
    editedItem: any = {
      cityId: null,
      countyId: null,
      stateId: null,
      ownershipCity: null,
      ownershipCounty: null,
      ownershipState: null,
      ownershipRailroad: null,
      structureType: null,
      sdFo: null,
      yearBuilt: null,
      maintainedBy: null,
      permitRating: null,
      paseo: null,
      roadway: null,
      nhs: null,
      id: -1,
      lat: 34.4127176,
      lng: -118.5533852,
      btDistrict: null,
      lmdZone: null,
      annexationDate: null,
    }

    @Prop() readonly item!: any
    @Prop() readonly tab!: number
    @Prop() readonly id!: number

    public editItem(item: object ): void {
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    }

    public save(editedItem: any): void {
      this.$store.dispatch('bridge/updateGeneralInfo', editedItem)
    }


    //getters
    get getLatestPermitRating(): string {
      if(this.item.bridge_permit_ratings.length > 0)
        return this.item.bridge_permit_ratings[0].rating
      return ''
    }
    get getReload(): boolean {
      return this.$store.getters['bridge/getReload']
    }
    get getMessage(): string {
      return this.$store.getters['bridge/getMsg']
    }
    get getLoading(): boolean {
      return this.$store.getters['bridge/getLoading']
    }
    get getAdminPermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }
    get getEditPermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Editor') ||
              this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }


    @Watch('getReload')
    reload(val: boolean) {
      if(val && this.tab == 0) {
        this.$store.dispatch('bridge/getGeneralInfo', { id: this.id })
        this.$store.dispatch('bridge/getBridges')
        this.$store.commit('bridge/setReload', false)
      }
    }
    @Watch('getGeneralInfo')
    setItems(val: any) {
      //this.$store.commit('bridge/setReload', false)
    }
  }

